import Vue from 'vue'
import Vuex from 'vuex'


import header from './modules/header'
import darkMode from './modules/darkMode'
import role from './modules/role'
import users from './modules/users'
import permission from './modules/permission'
import user from './modules/user'
import auth from './modules/auth'
import abilities from './modules/abilities'
import loginCard from './modules/loginCard'
import language from './modules/language'
import notifications from './modules/notifications'
import submission from './modules/submission'
import workflow from './modules/workflow';
import workflowsteps from './modules/workflowsteps';
import workflownodes from './modules/workflownodes';
import workflowcondition from './modules/workflowcondition';
import workflowactionlog from './modules/workflowactionlog';
import wfactionlogs_actioned from './modules/wfactionlogs_actioned';


import VuexPersist from 'vuex-persist'
import { abilityPlugin, ability as appAbility } from './ability'

Vue.use(Vuex)

export const ability = appAbility

const vuexLocalStorage = new VuexPersist({
  key: 'kmh', // The key to store the state on in the storage provider.
  storage: window.localStorage, // or window.sessionStorage or localForage
  // Function that passes the state and returns the state with only the objects you want to store.
  // reducer: state => state,
  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  filter: mutation => (true)
})




export default new Vuex.Store({
    plugins: [
      vuexLocalStorage.plugin,
      abilityPlugin
    ],
  
    modules: {
        header,
        language,
        role,
        users,
        user,
        auth,
        permission,
        abilities,
        loginCard,
        darkMode,
        notifications,
        submission,
        workflow,
        workflowsteps,
        workflownodes,
        workflowcondition,
        workflowactionlog,
        wfactionlogs_actioned,
    }
});